<template>
    <div id="markdown-editor">
        <v-card plain>
            <v-textarea
                auto-grow
                outlined
                class="pa-0 ma-0"
                :placeholder="'Ketik ' + title"
                rows="3"
                v-model="content"
            >
            </v-textarea>
            <v-card-actions class="pt-0">
                <v-btn
                    v-if="hasUpload"
                    elevation="0"
                    fab
                    small
                    color="white"
                    class="overflow-visible"
                    @click="$refs.up.click()"
                >
                    <v-icon dark> mdi-image </v-icon>
                    <input
                        ref="up"
                        type="file"
                        @change="imageUploaded($event)"
                        style="display: none"
                        accept="image/*"
                    />
                </v-btn>
                <v-btn
                    v-if="hasUpload"
                    elevation="0"
                    fab
                    small
                    color="white"
                    class="overflow-visible"
                    @click="explore()"
                >
                    <v-icon dark> mdi-music-box-multiple </v-icon>
                </v-btn>
                <v-spacer></v-spacer>

                <template v-if="type === 'jawaban'">
                    <span> Status Pilihan </span>
                    <v-select
                        placeholder="Pilih"
                        outlined
                        class="pa-0 ml-2 mt-3"
                        small
                        style="max-width: 150px"
                        v-model="status"
                        :items="[
                            { text: 'Benar', value: true },
                            { text: 'Salah', value: false },
                        ]"
                    ></v-select>
                </template>

                <!-- <v-btn text outlined class="mx-4 my-2" @click="preview"> -->

                <v-btn
                    v-if="$route.name != 'Form'"
                    text
                    outlined
                    class="mx-4 my-2"
                    @click="$emit('preview', content)"
                >
                    Preview {{ title }}
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="675px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>Preview {{ title }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text
                        width="100%"
                        class="py-2"
                        v-html="parseLatex(content)"
                    >
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                        <v-btn
                            dark
                            color="blew"
                            elevation="0"
                            @click="dialog.value = false"
                            >Tutup</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-model="showPod"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showPod = false"
            scrollablex
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>Pilih File Audio</v-card-title>
                    <v-card-text width="100%">
                        <app-datatable
                            :items="rows"
                            :headers="headers"
                            :hasAction="false"
                            :hasPreview="true"
                            :has-custom-pagination="false"
                            :custom-pagination-current-page="1"
                            :custom-pagination-per-page="10"
                            :has-custom-search="false"
                            v-on:dblClicked="selectItem($event)"
                        ></app-datatable>
                    </v-card-text>
                    <v-card-text>
                        <div class="text-h2"></div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn color="blew" @click="dialog.value = false"
                            >Tutup</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import FileUpload from "@/modules/global/components/plugins/FileUpload";
import Modal from "@/modules/global/components/plugins/Modal";
import PodbeanExplorer from "@/modules/global/components/plugins/PodbeanExplorer";
import { applyOssCredentials } from "@/modules/global/services/oss";
import showdown from "showdown";
import uniqid from "uniqid";

export default {
    name: "markdown-editor",

    components: {
        "app-datatable": DataTable,
        "app-fileupload": FileUpload,
        "app-modal": Modal,
        "app-podbean-explorer": PodbeanExplorer,
    },

    props: [
        "readOnly",
        "value",
        "context",
        "title",
        "hasUpload",
        "type",
        "answer",
    ],

    data: function () {
        return {
            math: null,
            compiledContent: "",
            showModal: false,
            showPod: false,
            content: "",
            status: false,
            headers: [
                { text: "No", value: "no" },
                { text: "Filename", value: "filename" },
                { text: "Date", value: "date" },
                { text: "Aksi", value: "actions" },
            ],
            rows: [],
            items: [],
        };
    },

    methods: {
        preview: function () {
            // var converter = new showdown.Converter();
            // var compiledContent = this.content.replace(/&gt;/g, ">");
            // compiledContent = compiledContent.replace(/&lt;/g, "<");
            // compiledContent = compiledContent.replace(/&amp;/g, "&");

            // compiledContent = this.compileInlineLatex(compiledContent);
            // compiledContent = this.compileBlockLatex(compiledContent);
            // alert(compiledContent);

            // // this.compiledContent = converter.makeHtml(compiledContent);
            this.showModal = true;
        },

        parseLatex: function (content) {
            var converter = new showdown.Converter();

            alert(content);

            var compiledContent = content.replace(/&gt;/g, ">");
            compiledContent = compiledContent.replace(/&lt;/g, "<");
            compiledContent = compiledContent.replace(/&amp;/g, "&");

            compiledContent = this.compileInlineLatex(compiledContent);
            compiledContent = this.compileBlockLatex(compiledContent);
            return converter.makeHtml(compiledContent);
        },

        compileInlineLatex: function (content) {
            var pattern = /\\\\((.*?)\\\\)/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula = katex.renderToString(match[1], { trust: true });
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        compileBlockLatex: function (content) {
            var pattern = /\$\$(.*?)\$\$/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula =
                    '<p class="text-center">' +
                    katex.renderToString(match[1], { trust: true }) +
                    "</p>";
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        imageUploaded: async function (e) {
            var file = e.target.files[0];
            if (!file) return;
            if (file.type.indexOf("image") == -1) return;

            try {
                await applyOssCredentials(AWS);
            } catch (error) {
                this.$store.commit("showAlert", {
                    message: `Terjadi kesalahan pada upload!`,
                    submessage: error.message,
                    type: "error",
                });
                return;
            }

            var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT;
            var bucket = new AWS.S3({
                endpoint: spaceEndpoint,
            });

            var fileExt = file.name.substr(-4);
            var filename = uniqid() + fileExt;
            var params = {
                Bucket: process.env.VUE_APP_OSS_BUCKET,
                Key: "gallery/" + this.context + "/" + filename,
                Body: file,
                ContentType: file.type,
                ACL: "public-read",
            };

            var context = this;
            bucket.upload(params, function (error, data) {
                if (!error) {
                    context.content += "\n![Alt](" + data.Location + ")";
                }
            });
        },

        itemSelected: function (content) {
            this.content += content;
        },

        explore: function () {
            var context = this;
            var url = "https://anchor.fm/s/f78dcdc/podcast/rss";

            this.isLoading = true;
            this.rows = [];
            axios.get(url).then(function (response) {
                if (response.status === 200) {
                    var domParser = new DOMParser();
                    var xmlDoc = domParser.parseFromString(
                        response.data,
                        "text/xml"
                    );
                    var items = xmlDoc.getElementsByTagName("item");

                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        var url = item
                            .getElementsByTagName("enclosure")[0]
                            .getAttribute("url");
                        var row = {
                            no: i,
                            id: i,
                            filename:
                                item.getElementsByTagName("title")[0]
                                    .textContent,
                            date: item.getElementsByTagName("pubDate")[0]
                                .textContent,
                            preview: url,
                        };

                        context.rows.push(row);
                        context.items.push(item);
                    }

                    context.isLoading = false;
                    context.showPod = true;
                }
            });
        },

        selectItem: function (item) {
            var item = this.items[item.id];
            var title = item.getElementsByTagName("title")[0].textContent;
            var resourceId = item
                .getElementsByTagName("link")[0]
                .textContent.split("/")[5];
            var link = "https://anchor.fm/nfjuara/embed/episodes/" + resourceId;
            var iframeString =
                '<iframe src="' +
                link +
                '" height="102px" width="100%" frameborder="0" scrolling="no"></iframe>';

            this.showPod = false;
            this.itemSelected(iframeString);
        },
    },

    watch: {
        content: function (input) {
            this.$emit("content-updated", input);
        },

        value: function (val) {
            this.content = this.value;
        },

        status: function (val) {
            this.$emit("status-updated", val);
        },

        answer: function (val) {
            this.status = val;
        },
    },

    mounted: function () {
        this.content = this.value;
        this.status = this.answer;
    },
};
</script>

<style>
.v-select
    .v-input__control
    .v-input__slot
    .v-select__slot
    .v-select__selections {
    padding: 0 !important;
    min-height: 0 !important;
}

/* .v-select-list .v-list-item {
  min-height: 0 !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 4px 0 !important;
} */
</style>



// WEBPACK FOOTER //
// MarkdownEditor-c.vue?aaf0f2ee